export class ObservableContainer<T> {
  private _value: T;

  private _subscribers: Set<(value: T) => void> = new Set();

  constructor(value: T) {
    this._value = value;
  }

  get value(): T {
    return this._value;
  }

  set value(value: T) {
    this._value = value;
    Array.from(this._subscribers).forEach((subscriber) => subscriber(value));
  }

  subscribe(listener: (value: T) => void): () => void {
    this._subscribers.add(listener);
    return () => this._subscribers.delete(listener);
  }
}
